import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhoFor() {
  const scenarios = ['You have junk, debris, or clutter that needs to disappear — fast', "You're a landlord with a trashed unit you need ready to rent", "You're a contractor who needs a site cleaned up between phases", "You're a real estate agent prepping a property for sale", "You're dealing with an estate, eviction, or foreclosure property", "You're just done looking at the pile and ready to make one call"];
  return <section className="py-24 bg-white" data-id="element-500">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-501">
        <div className="text-center mb-12" data-id="element-502">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-4" data-id="element-503">
            THIS ISN'T FOR EVERYONE — BUT IT MIGHT BE{' '}
            <span className="text-[#C8102E]" data-id="element-504">PERFECT FOR YOU</span>
          </motion.h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-505">
            Jose's is the right call if:
          </p>
        </div>

        <div className="space-y-4" data-id="element-506">
          {scenarios.map((scenario, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex items-center gap-4 p-4 md:p-6 bg-[#F9F9F9] rounded-lg border border-gray-100 hover:border-[#C8102E]/30 transition-colors" data-id="element-507">
              <CheckCircle2 className="text-[#C8102E] flex-shrink-0" size={28} data-id="element-508" />
              <span className="text-lg md:text-xl font-medium text-gray-800" data-id="element-509">
                {scenario}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}